import React, { FC } from 'react'
import classNames from 'classnames'
import useWindowSize from 'components/util/useWindowSize'

type VisionColumnsType = {
  columnsClasses?: string
  emptyLeftColumn?: boolean
  category?: string
  title: string
  titleClasses?: string
  subtitle?: string
  text?: string
  textClasses?: string
  className?: string
}

const VisionColumns: FC<VisionColumnsType> = ({
  category,
  children,
  className = '',
  columnsClasses = 'col-xxxl-8 col-xxl-6 col-lg-8',
  emptyLeftColumn = false,
  subtitle,
  text,
  textClasses = 'pe-xxxl-30 pe-sm-26 pe-4',
  title,
  titleClasses = 'pe-lg-0 pe-8',
}) => {
  const size = useWindowSize()
  return (
    <div className={classNames('row position-relative', className)}>
      {emptyLeftColumn && <div className='col-xxxl-7 col-xxl-6 col-lg-7' />}
      <div className={columnsClasses}>
        {category && (
          <p
            className={'h4 h4--small text-bold mb-lg-3 mb-6'}
            dangerouslySetInnerHTML={{
              __html: category,
            }}
          />
        )}
        <h2
          className={classNames(
            'text-bold mb-6',
            size.isLgOrHigher ? 'fs-fluid-36-80 lh-105' : 'h3',
            titleClasses,
          )}
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        {subtitle && (
          <h3
            className={classNames(
              'mb-lg-3 mb-6',
              size.isLgOrHigher ? 'h1 h1--lh2' : 'text-xxl text-xxl--lh2',
            )}
          >
            {subtitle}
          </h3>
        )}
        {text && (
          <div
            className={classNames(
              'h4 h4--large h4--mobile-small',
              textClasses,
              size.isLgOrHigher ? 'text-semibold' : 'text-normal',
            )}
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          />
        )}
      </div>
      {children && size.isLgOrHigher && <>{children}</>}
    </div>
  )
}

export default VisionColumns
